import React from "react";
import { Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";

class SoftwareCatalogInfoCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  softwareCatalogProviderToString() {
    return this.props.softwareCatalog?.provider === 0 ? "CAMPLA" : "Chocolatey";
  }

  render() {
    const { t } = this.props;

    const body = (
      <>
        <Row className="pageTitle">
          <Col>
            <h2>{t("SingleSoftwareCatalog.Title")}</h2>
          </Col>
          <Col>
            <div style={{ float: "right" }}>
              <DropdownButton
                onClick={event => event.stopPropagation()}
                id="dropdown-basic-button"
                title={<FontAwesomeIcon icon={faCogs} />}
                className="btn-green"
              >
                <Dropdown.Item onClick={this.props.onEdit}>
                  {t("SingleSoftwareCatalog.ActionCell.EditOption")}
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <div>
              <b>{t("SingleInstanceTemplate.BasicInformation.Name")}:</b>{" "}
              {this.props.softwareCatalog.name}
            </div>
            <div>
              <b>{t("SingleSoftwareCatalog.BasicInformation.Provider")}:</b>{" "}
              {this.softwareCatalogProviderToString()}
            </div>
          </Col>
          <Col style={{ borderLeft: "1px solid gray" }}>
            <div>
              <b>{t("SingleSoftwareCatalog.BasicInformation.Packages")}:</b>{" "}
              {this.props.softwareCatalog.packages.length}
            </div>
          </Col>
        </Row>
      </>
    );

    return <div>{body}</div>;
  }
}

export default withTranslation()(SoftwareCatalogInfoCard);
